import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import PropTypes from 'prop-types';

const WhiteLabelContext = createContext();

export function useWhiteLabelContext() {
  return useContext(WhiteLabelContext);
}

const initialState = {
  isWhiteLabeled: false,
  isEnclosedMode: false,
  hasWhiteLabelClient: false,
  urlLogo: null,
  labelProvidedBy: '',
  urlESS: null,
  isLoading: true,
  backgroundColor: '',
  labelColor: '',
  noHeader: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_WHITE_LABEL_STATE':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default function WhiteLabelProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setWhiteLabelState = useCallback((whiteLabel) => {
    dispatch({ type: 'SET_WHITE_LABEL_STATE', payload: whiteLabel });
  }, []);

  const value = useMemo(
    () => ({
      state,
      actions: {
        setWhiteLabelState,
      },
    }),
    [state]
  );

  return (
    <WhiteLabelContext.Provider value={value}>
      {children}
    </WhiteLabelContext.Provider>
  );
}

WhiteLabelProvider.propTypes = { children: PropTypes.node.isRequired };
